import type { Pin } from '../../../../types/photo.types';

export function keepSubmittablePins(pins: Pin[]): Pin[] {
  return pins
    .filter(p => p.label.trim() || p.audioBlob || p.audioUrl)
    .map((p, i) => ({ ...p, index: i + 1 }));
}
